var _circle, _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _ellipse, _circle2, _path8, _ellipse2, _circle3, _path9, _rect2, _path10, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSavannahJeepContrast = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.6586 52.4456H75.391C76.0598 52.4456 76.6019 52.9877 76.6019 53.6565V58.8027C76.6019 59.4714 76.0598 60.0136 75.391 60.0136H10.2685C9.59977 60.0136 9.05762 59.4714 9.05762 58.8027V57.2265C9.05762 56.5577 9.59976 56.0156 10.2685 56.0156H71.2368C72.4578 56.0156 73.4477 55.0257 73.4477 53.8047V53.6565C73.4477 52.9877 73.9898 52.4456 74.6586 52.4456Z",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1019 52.2917C77.1019 52.1005 76.9469 51.9456 76.7557 51.9456V51.9456C76.5645 51.9456 76.4095 52.1005 76.4095 52.2917V57.3747C76.4095 58.3196 75.6435 59.0856 74.6986 59.0856H9.27162C8.87729 59.0856 8.55762 59.4053 8.55762 59.7996V59.7996C8.55762 60.1939 8.87729 60.5136 9.27162 60.5136H75.391C76.3359 60.5136 77.1019 59.7476 77.1019 58.8027V52.2917Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1875 19.1696H52.5011L58.6707 40.7632H56.3571L50.1875 19.1696Z",
    fill: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6367 24.2964H51.3449L54.9377 37.9492H30.6367V24.2964Z",
    fill: "white",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.8984,
    y: 30.4668,
    width: 13.6528,
    height: 8.2544,
    rx: 1.21092,
    fill: "white",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6768 20.4912C31.6768 18.8425 29.5742 18.1477 28.5918 19.4718L15.965 36.4906C15.1273 37.6196 15.9332 39.2209 17.339 39.2209H19.6506C19.2912 38.671 19.244 37.9219 19.6791 37.3004L25.4789 29.015C26.4382 27.6446 28.5915 28.3233 28.5915 29.9961L28.5914 38.2815C28.5914 38.6285 28.4881 38.9513 28.3107 39.2209H29.9658C30.9107 39.2209 31.6767 38.4549 31.6767 37.51L31.6768 20.4912Z",
    fill: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8945 42.9818C10.8945 40.6195 12.8095 38.7045 15.1718 38.7045H71.267C73.6292 38.7045 75.5443 40.6195 75.5443 42.9818V55.8405H10.8945V42.9818Z",
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7072 58.6167C72.7072 64.7932 67.7001 69.8004 61.5235 69.8004C55.347 69.8004 50.3398 64.7932 50.3398 58.6167C50.3398 52.4401 55.347 47.433 61.5235 47.433C67.7001 47.433 72.7072 52.4401 72.7072 58.6167Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.5235,
    cy: 58.6165,
    rx: 5.84184,
    ry: 5.84184,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.524,
    cy: 58.6171,
    r: 4.38138,
    fill: "#1E1E1E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2404 58.3729C36.2404 64.5495 31.2333 69.5566 25.0567 69.5566C18.8802 69.5566 13.873 64.5495 13.873 58.3729C13.873 52.1963 18.8802 47.1892 25.0567 47.1892C31.2333 47.1892 36.2404 52.1963 36.2404 58.3729Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.0567,
    cy: 58.3727,
    rx: 5.84184,
    ry: 5.84184,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0572,
    cy: 58.3733,
    r: 4.38138,
    fill: "#1E1E1E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6099 44.6188C76.6099 45.847 76.4015 46.9355 76.0837 47.6984C75.9243 48.0809 75.7472 48.3578 75.5762 48.5315C75.4069 48.7033 75.2739 48.746 75.1819 48.746C75.0899 48.746 74.957 48.7033 74.7876 48.5315C74.6166 48.3578 74.4395 48.0809 74.2801 47.6984C73.9623 46.9355 73.7539 45.847 73.7539 44.6188C73.7539 43.3905 73.9623 42.302 74.2801 41.5392C74.4395 41.1566 74.6166 40.8797 74.7876 40.7061C74.957 40.5342 75.0899 40.4916 75.1819 40.4916C75.2739 40.4916 75.4069 40.5342 75.5762 40.7061C75.7472 40.8797 75.9243 41.1566 76.0837 41.5392C76.4015 42.302 76.6099 43.3905 76.6099 44.6188Z",
    fill: "white",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 39.9916,
    width: 3.856,
    height: 14.6528,
    rx: 1.71092,
    fill: "#1E1E1E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7207 16.4704C32.7207 18.2351 31.6264 19.4408 30.5215 19.4408C29.4165 19.4408 28.3223 18.2351 28.3223 16.4704C28.3223 14.7057 29.4165 13.5 30.5215 13.5C31.6264 13.5 32.7207 14.7057 32.7207 16.4704Z",
    fill: "white",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.0762,
    y: 40.7633,
    width: 6.9408,
    height: 2.3136,
    rx: 1.1568,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSavannahJeepContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SavannahJeep-contrast.a9678eb6ce066d3e5cf0c7f850c64c52.svg";